import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

const FineArtPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://martinrichens.art';
  
  const artworks = [
    {
      id: 1,
      title: 'Vrrooomm!',
      year: '2018',
      medium: 'Oil and Gold Leaf on Wood',
      dimensions: '62cm x 150cm',
      image: 'https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/136025c0de7663bf1b822a4577407cf4.jpeg',
    },
    {
      id: 2,
      title: 'Nooooo!',
      year: '2021',
      medium: 'Oil and Gold Leaf on Wood',
      dimensions: '62cm x 150cm',
      image: 'https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/3ab26ec32635a2d7f1533ece5f3f3dce.jpeg',
    },
    {
      id: 3,
      title: 'HaHaHa!',
      year: '2021',
      medium: 'Oil and Gold Leaf on Wood',
      dimensions: '62cm x 150cm',
      image: 'https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/5a5eb3c04953d348eda51f8cf7d2dd6d.jpeg',
    },
    {
      id: 4,
      title: 'Aaarrggh!',
      year: '2021',
      medium: 'Oil and Gold Leaf on Wood',
      dimensions: '62cm x 150cm',
      image: 'https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/83d2f408a9053256029076de05482423.jpeg',
    },
    {
      id: 5,
      title: 'Bazooka Joe and the Capitalist Death Ray',
      year: '2018',
      medium: 'Oil and Gold Leaf on Wood',
      dimensions: '46cm x 32cm',
      image: 'https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/15fb099dbcb5573e42580aceeede78b7.jpeg',
    }
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Fine Art Collection - Martin Richens",
    "description": "Explore Martin Richens' fine art collection featuring contemporary oil paintings with gold leaf on wood. Original artworks exploring themes of modern society and creative expression.",
    "url": `${siteUrl}/fine-art`,
    "mainEntity": {
      "@type": "ImageGallery",
      "name": "Fine Art Gallery",
      "creator": {
        "@type": "Person",
        "name": "Martin Richens"
      },
      "image": artworks.map(artwork => ({
        "@type": "ImageObject",
        "name": artwork.title,
        "contentUrl": artwork.image,
        "description": `${artwork.title} - ${artwork.medium}, ${artwork.dimensions}, ${artwork.year}`
      }))
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Fine Art Collection - Martin Richens | Contemporary Oil Paintings"
        description="Explore Martin Richens' fine art collection featuring contemporary oil paintings with gold leaf on wood. Original artworks exploring themes of modern society and creative expression."
        keywords="Martin Richens fine art, contemporary oil paintings, gold leaf art, modern art collection, original paintings, art for sale"
        canonical={`${siteUrl}/fine-art`}
        ogImage="https://static.readdy.ai/image/bfb5433654973d40d0c52d729e2b895a/3ab26ec32635a2d7f1533ece5f3f3dce.jpeg"
        schema={schema}
      />
      
      <Navbar />

      {/* Header */}
      <section className="pt-32 pb-16 px-8 md:px-16">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8">Fine Art</h2>
        </div>
      </section>

      {/* Gallery - Single Column */}
      <section className="pb-20">
        <div className="px-[28px]">
          <div className="space-y-16">
            {artworks.map((artwork) => (
              <div key={artwork.id} className="group cursor-pointer">
                <div className="overflow-hidden shadow-lg mb-6 transform transition-all duration-300 group-hover:shadow-2xl">
                  <img
                    src={artwork.image}
                    alt={artwork.title}
                    className="w-full h-auto object-cover object-top"
                  />
                </div>
                <div className="space-y-1 text-center">
                  <h3 className="text-2xl font-serif italic text-gray-800">{artwork.title}</h3>
                  <p className="text-base text-gray-600">{artwork.medium}</p>
                  <p className="text-base text-gray-500">{artwork.dimensions}</p>
                  <p className="text-base text-gray-500">{artwork.year}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FineArtPage;
